import UnansweredQuestion from './UnansweredQuestion.component';

export default UnansweredQuestion;
